import React from 'react'
import ResponsiveOrdinalFrame from "semiotic/lib/ResponsiveOrdinalFrame"
import moment from 'moment'
import cs from 'classnames'
import palette from 'helpers/palette'
import './style.css'


/* global API */

const StatProcess = () => {

    const colorSectorProgression = [7, 11, 0, 4, 8, 1, 5, 9, 2, 6, 10, 3,]
    const colorIndexProgression = [5, 3, 6, 4, 7, 2, 8, 1, 0]

    const initialFrameProps = {
        size: [800, 400],
        margin: { left: 80, bottom: 90, right: 40, top: 40 },
        responsiveWidth: true,

        // Style
        type: "bar",
        style: d => ({
            fill: palette
                [colorSectorProgression[d.themeIndex % colorSectorProgression.length]]
                [colorIndexProgression[Math.floor(d.themeIndex / colorSectorProgression.length) % 9]]
                .HEX
        }),

        // Axes
        // oLabel: true,
        oLabel: e => {
            let m = moment(e + '.' + moment().format('YYYY'), "DD.MM.YY").format()
            let d = new Date(m);
            return (
                <text className={cs({'weekend': !d.getDay() || (d.getDay() === 6)})}>
                    {d.getDate() + '.' + (
                    d.getMonth() + 1 < 10
                        ? '0' + (d.getMonth() + 1)
                        : (d.getMonth() + 1)
                    )}
                </text>
            )
        },
        oAccessor: e => {
            let d = new Date(e.date)
            return d.getDate() + '.' + (
                d.getMonth() + 1 < 10
                    ? '0' + (d.getMonth() + 1)
                    : (d.getMonth() + 1)
                )
        },
        oPadding: 2,
        rAccessor: "count",
        axes: [
            {
                orient: "left",
                label: { name: "Сообщений", locationDistance: 60 },
            }
        ],

        // Tooltip
        pieceHoverAnnotation: true,
        tooltipContent: d => <div className="stat__tooltip">{d.processTitle}<br />{d.count}</div>,
    }

    const [frameProps, setFrameProps] = React.useState(initialFrameProps)
    const [processList, setProcessList] = React.useState([])

    React.useEffect(() => {
        API.instance().getProcessActivityStat().then(data => {

            // Frame Props
            frameProps.data = [].concat.apply(
                [], data
                    .filter(el => el.stat && el.stat.length)
                    .map((processData, i) =>
                        processData.stat
                            .map( stat => ({...stat, ...{
                                'processTitle': processData.process.title,
                                'processId': processData.process.id,
                                'themeIndex': i
                            }})
                    )
            )).sort((a, b) => (
                (new Date(a.date)).getTime() === (new Date(b.date)).getTime()
                    ? a.processId - b.processId
                    : (new Date(a.date)).getTime() - (new Date(b.date)).getTime()
            ))
            setFrameProps(frameProps)

            // ProcessList
            const processList = data
                .filter(el => el.stat && el.stat.length)
                .map((el, i) => ({
                    ...el.process,
                    ...{'themeIndex': i}
                }))
            setProcessList(processList)
        })
    }, [frameProps])

    return (
        <div className="stat">
            <ResponsiveOrdinalFrame {...frameProps} />

            <div className="legend container">
                {processList.map(process => (
                   <div
                    className="legend__item"
                    key={process.id}
                    style={{ color: palette
                            [colorSectorProgression[process.themeIndex % colorSectorProgression.length]]
                            [colorIndexProgression[Math.floor(process.themeIndex / colorSectorProgression.length) % 9]]
                            .HEX
                        }}>
                        ◼︎ {process.title}
                    </div>
                ))}
            </div>
        </div>
    )
}

export default StatProcess
